import { forwardRef } from 'react';
import { useUserName } from '../hooks/useUserName';

/**
 * The User ID counterpart to EmployeePicker - for the fields that
 * genuinely need a system account (project manager, approver,
 * reviewer) rather than an employee record. Same drop-in
 * react-hook-form pattern:
 *   <UserPicker {...register('project_manager_id', { required: true, valueAsNumber: true })} />
 */
export const UserPicker = forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement>>(
  function UserPicker(props, ref) {
    const { users, isLoading } = useUserName();
    // Only active accounts are offered for selection - useUserName()
    // itself must never filter, since it also resolves names for
    // inactive users in historical records (past approvers, etc.).
    const activeUsers = users.filter((u) => u.is_active);

    return (
      <select ref={ref} {...props} disabled={isLoading || props.disabled}>
        <option value="">{isLoading ? 'Loading users…' : 'Select user…'}</option>
        {activeUsers.map((u) => (
          <option key={u.id} value={u.id}>{u.full_name}</option>
        ))}
      </select>
    );
  }
);
